export default {
  formsList: state => state.formsList,
  questionsByFormId: state => state.questionsByFormId,
  currentFormId: state => state.currentFormId,
  errors: state => state.errors
};
